import { useCampaigns } from '../../../../hooks/queries';

export const useSelectedCampaigns = (
  selectedCampaignIds: number[],
  search?: string,
  page?: number,
  isRecurring?: boolean,
) =>
  useCampaigns({
    search,
    ids: selectedCampaignIds,
    page,
    isRecurring,
  });
